<template>
  <div id="formTable">
    <div class="lyleft">
      <Select v-model="status" @on-change="selectChange">
        <Option
          v-for="(x, index) in $t('payStatus')"
          :key="index"
          :value="index"
          >{{ x.name }}</Option
        >
      </Select>
      <start-end ref="startEnd" timeModel="4,3,2"></start-end>
      <Button @click="chaxun" type="primary" size="small" class="chaxun"
        >立即查询</Button
      >
    </div>
    <div id="ddas">
      <Button size="small" @click="openCarDrawer = true">筛选</Button>
      <Button @click="tianjia" size="small">新增</Button>
      <Button @click="daoru" size="small">导入</Button>
      <Button @click="daochu" size="small">导出</Button>
    </div>
    <Drawer
      title="选择需要查看的车辆"
      placement="right"
      :closable="true"
      :mask="false"
      v-model="openCarDrawer"
      width="450"
      draggable
    >
      <car-tool @cars="reCars" :isMore="true"></car-tool>
    </Drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      status: "3",
      deviceIdList: [],
      openCarDrawer: false,
    };
  },
  methods: {
    daochu() {
      this.$emit("exportAll");
    },
    reCars(x) {
      this.$emit("cars", x);
    },
    tianjia() {
      this.$emit("reOpenWin");
    },
    daoru() {
      this.$emit("daoru");
    },
    selectChange(v) {
      this.$emit("selectChange", v);
    },
    chaxun() {
      var v = this.$refs.startEnd.getTimeObj();
      this.$emit("timeObj", v);
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/payTool.vue